export enum UsageMeteringActionTypes {
  SET_USAGE_METERING_DATA = 'SET_USAGE_METERING_DATA',
  CLEAR_USAGE_METERING_DATA = 'CLEAR_USAGE_METERING_DATA',
  SET_USAGE_DATE_RANGE = 'SET_USAGE_DATE_RANGE',
  SET_USAGE_FILTERS = 'SET_USAGE_FILTERS',
  CLEAR_USAGE_FILTERS = 'CLEAR_USAGE_FILTERS',
  SET_PAGE_NUMBER = 'SET_PAGE_NUMBER',
}

export interface DateRange {
  startDate: string
  endDate: string
}

export interface Record {
  name: string
  pricePerBandwidth: string
  quantity: string
  price: string
}

export enum UsageStatusMap {
  SUBMITTED = 'SUBMITTED',
  FAILED = 'FAILED',
  COMPLETED_WITH_SUCCESS = 'COMPLETED_WITH_SUCCESS',
  COMPLETED_WITHOUT_SUCCESS = 'COMPLETED_WITHOUT_SUCCESS',
  SUBMISSION_FAILED_BY_AWS = 'SUBMISSION_FAILED_BY_AWS',
  SUBMISSION_FAILED_BY_LABRA = 'SUBMISSION_FAILED_BY_LABRA',
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DUPLICATE = 'DUPLICATE',
  OTHER = 'OTHER',
}

export interface BuyerDetails {
  cloudCustomerId: string
  labraSubscriptionId: string
  buyerCompanyName: string
  buyerLogoUrl: string
}

export interface ProductDetails {
  cloud: string
  cloudProductId: string
  productName: string
  cloudProductCode?: string
  purchasePlan: string
}

export interface UsageDimensions {
  labraDimensionId: string
  price: number
  name: string
  dimensionUnit: string
}

export interface UsageData {
  labraMeteringId: string
  meteredQuantity: number
  batchId: string
  cloudMeteringStatus: string
  labraMeteringStatus: string
  meteringSubmissionTimestamp: string
  buyerDetails: BuyerDetails
  productDetails: ProductDetails
  dimension: UsageDimensions
  link: string
}

export interface LinksData {
  self: string
  nextPage: string
  previousPage: string
}

export interface MetaData {
  pageNumber: number
  pageSize: number
  totalCount: number
  sortBy: string
  sortOrder: string
  links?: LinksData
}

export interface UsageFilterState {
  status: string[]
  cloud: string[]
  dateRangeFilter?: { startDate?: string; endDate?: string }
}

export interface UsageDataState {
  data: UsageData[]
  dateRange: DateRange
  metaData: MetaData
  filters: UsageFilterState
}

export type UsageMeteringAction =
  | {
      type: UsageMeteringActionTypes.SET_USAGE_METERING_DATA
      payload: UsageDataState
    }
  | {
      type: UsageMeteringActionTypes.CLEAR_USAGE_METERING_DATA
    }
  | {
      type: UsageMeteringActionTypes.SET_USAGE_DATE_RANGE
      payload: DateRange
    }
  | {
      type: UsageMeteringActionTypes.SET_USAGE_FILTERS
      payload: UsageFilterState
    }
  | { type: UsageMeteringActionTypes.CLEAR_USAGE_FILTERS }
  | {
      type: UsageMeteringActionTypes.SET_PAGE_NUMBER
      payload: number
    }
